interface EarlyBirdSectionProps {
  /** Title rows — first white, second highlight (primary blue) */
  titleLine1: string
  titleLine2: string
  bodyLine1: string
  bodyLine2: string
  ctaLabel: string
  onCtaClick?: () => void
  imageUrl: string
  imageAlt?: string
}

export function EarlyBirdSection({
  titleLine1,
  titleLine2,
  bodyLine1,
  bodyLine2,
  ctaLabel,
  onCtaClick,
  imageUrl,
  imageAlt = '',
}: EarlyBirdSectionProps) {
  return (
    <section id="early-bird" data-marketing-section="" className="relative w-full bg-qb-text-high overflow-hidden tracking-[-0.6px]">
      {/* BG image with 50% opacity + dark gradient overlay */}
      <div className="absolute inset-0 pointer-events-none">
        <img
          src={imageUrl}
          alt={imageAlt}
          aria-hidden
          className="object-cover absolute inset-0 w-full h-full"
        />
        <div className="absolute inset-0 bg-gradient-to-b to-transparent from-black/70" />
      </div>

      <div className="relative mx-auto max-w-[1136px] px-6 py-14 lg:py-26 flex flex-col items-center gap-10 text-center">
        <div className="flex flex-col gap-2.5 font-bold text-[28px] lg:text-[40px] leading-[1.4] lg:leading-[1.2] [filter:drop-shadow(0_0_40px_black)]">
          <p className="text-white whitespace-pre-line lg:whitespace-normal">
            {titleLine1}
          </p>
          <p className="whitespace-pre-line text-qb-primary lg:whitespace-normal">
            {titleLine2}
          </p>
        </div>
        <div className="text-white font-normal text-[18px] lg:text-[20px] leading-[1.5] [filter:drop-shadow(0_0_40px_black)]">
          <p>{bodyLine1}</p>
          <p>{bodyLine2}</p>
        </div>
        <button
          type="button"
          onClick={onCtaClick}
          className="marketing-cta inline-flex items-center justify-center h-12 lg:h-14 px-6 rounded-full bg-qb-primary text-white font-medium lg:font-semibold text-[18px] lg:text-[20px] leading-[1.5] shadow-[0px_4px_4px_rgba(0,0,0,0.1)] hover:opacity-90 transition-opacity"
        >
          {ctaLabel}
        </button>
      </div>
    </section>
  )
}
